import React, { useState } from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';
import Input from 'components/ui/Input';

export default function InterestModal({ opportunity, onClose, onSubmit }) {
  const [amount, setAmount] = useState('');
  const [message, setMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);

  if (!opportunity) return null;

  const handleSubmit = (e) => {
    e?.preventDefault();
    setSubmitted(true);
    setTimeout(() => {
      onSubmit({ opportunity, amount, message });
      onClose();
    }, 1500);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: 'rgba(27,42,94,0.7)' }} onClick={onClose}>
      <div className="bg-white rounded-2xl w-full max-w-md shadow-2xl overflow-hidden" onClick={e => e?.stopPropagation()}>
        <div className="p-5 border-b flex items-center justify-between" style={{ borderColor: 'var(--color-border)', background: 'var(--color-primary)' }}>
          <div>
            <h3 className="font-heading font-semibold text-white text-lg">Express Interest</h3>
            <p className="font-caption text-sm text-white/70 mt-0.5" style={{ fontFamily: 'var(--font-caption)' }}>{opportunity?.name}</p>
          </div>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors" aria-label="Close">
            <Icon name="X" size={16} color="white" />
          </button>
        </div>

        {submitted ? (
          <div className="p-8 text-center">
            <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{ background: 'rgba(5,150,105,0.1)' }}>
              <Icon name="CheckCircle" size={32} color="var(--color-success)" />
            </div>
            <h4 className="font-heading font-semibold text-lg mb-2" style={{ color: 'var(--color-foreground)' }}>Interest Logged!</h4>
            <p className="font-caption text-sm" style={{ color: 'var(--color-muted-foreground)', fontFamily: 'var(--font-caption)' }}>
              The team at {opportunity?.name} has been notified. You'll receive updates on next steps.
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="p-5 space-y-4">
            <div className="p-3 rounded-lg flex items-start gap-2" style={{ background: 'rgba(133,113,77,0.08)', border: '1px solid rgba(133,113,77,0.3)' }}>
              <Icon name="Info" size={16} color="var(--color-accent)" className="mt-0.5 flex-shrink-0" />
              <p className="font-caption text-xs" style={{ color: 'var(--color-foreground)', fontFamily: 'var(--font-caption)' }}>
                Expressing interest is non-binding. Minimum investment is <strong>${opportunity?.minInvestment?.toLocaleString()}</strong>.
              </p>
            </div>

            <Input
              label="Intended Investment Amount (USD)"
              type="number"
              placeholder={`Min. $${opportunity?.minInvestment?.toLocaleString()}`}
              value={amount}
              onChange={e => setAmount(e?.target?.value)}
              required
            />

            <div>
              <label className="font-caption text-sm font-medium block mb-1" style={{ color: 'var(--color-foreground)', fontFamily: 'var(--font-caption)' }}>
                Message to Founder (Optional)
              </label>
              <textarea
                value={message}
                onChange={e => setMessage(e?.target?.value)}
                placeholder="Share why you're interested in this opportunity..."
                rows={3}
                className="w-full px-3 py-2 rounded-md border text-sm resize-none focus:outline-none focus:ring-2 focus:ring-yellow-500"
                style={{ borderColor: 'var(--color-border)', color: 'var(--color-foreground)', fontFamily: 'var(--font-caption)' }}
              />
            </div>

            <div className="flex gap-3 pt-1">
              <Button variant="outline" type="button" onClick={onClose} className="flex-1">Cancel</Button>
              <Button variant="default" type="submit" className="flex-1">Submit Interest</Button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}